import { RestUrl } from "../common/cyan.types";

export class DocsServiceInspectUrl {
  public static inspect: RestUrl = ["GET", "/internal/inspect"];
  public static externalInspect: RestUrl = ["GET", "/docs/v1"];
}
